export default __webpack_public_path__ + "static/media/logo_whistle.8c6cff69.svg";